import cx from "classnames";
import parse from "html-react-parser";

// Components
import Section from "../Section/SectionContainer";

// CSS
import styles from "./welcomeNews.module.scss";

/**
 * Constants
 */

export const WelcomeNews = (props) => {
    const {
            welcome_news,
    } = props;

    /**
     * Hooks
     */

    return (
        <Section
            classes={cx(styles.welcome_news_container, {
                [styles["welcome_news_container--hidden"]]: !welcome_news,
            })}
        >
          <h1>symphony news</h1>

            <div className={styles.welcome_news}>
                {welcome_news && <span>{parse(props.welcome_news)}</span>}
            </div>

        </Section>
    );
};
